<template>
  <div id="app" data-app>
    <div class="dvHeader-fx" v-if="$store.state.signedIn && this.$route.name != 'signin'"></div>

    <HeaderNav v-show="$store.state.signedIn && this.$route.name != 'signin'"></HeaderNav>

    <div class="dvBody" v-if="$store.state.signedIn && this.$route.name != 'signin'">
      <router-view/>
    </div> <!-- dvBody -->

    <div class="dvBody" v-if="this.$route.name == 'signin'">
      <router-view/>
    </div> <!-- dvBody -->

    <Footer v-if="$store.state.signedIn && this.$route.name != 'signin'"></Footer>
  </div>
</template>


<style>
  .col {
    flex-basis: auto!important;
  }

</style>
<script>
import M from 'materialize-css'
import HeaderNav from './components/HeaderNav.vue'
import Footer from './components/Footer.vue'

export default {
  data: () => ({
    drawer: null,
    drawerRight: null,
    right: false,
    left: false,
    items: [
      { text: 'Channels', icon: 'mdi-folder', route: 'admin_channels' },
      { text: 'Teams', icon: 'mdi-account-multiple', route: 'admin_teams' },
      { text: 'Users', icon: 'mdi-star', route: 'admin_users' }
    ]
  }),
  name: 'App',
  components: {
    HeaderNav,
    Footer
  },
  mounted () {
    this.$store.commit('setApiUrl', { url: process.env.VUE_APP_API_URL })
    this.$store.commit('resetRefreshCnt')
    M.AutoInit()
  }
}
</script>
